export default __webpack_public_path__ + "1850b2ec3ba19fa8af45468a4d6b40f5.svg";